import React, { useState, useEffect, useRef } from "react";
import stage2 from "../assets/new/stage-2.png";
import stage1 from "../assets/new/stage-1-1.jpeg";
import stage1a from "../assets/new/stage-1-2-opt-6.jpeg";
import stage3 from "../assets/new/stage-3-a-opt-3.jpeg";
import Title360 from "../assets/new/360-title.png";
import FPSImage from "./FPSImage";
import CenteredInstoBottle from "./CenteredInstoBottle";
import GameOverlay from "./GameOverlay";
import GamePanorama from "./GamePanorama";
import hotspotStore from "../utils/hotspotStore";
import deleteHotspot from "../utils/deleteHotspot";
import GameHint from "./GameHint";
import getFoundInstos from "../utils/getFoundInstos";
import { GAME_CONFIG } from "../config";

const stages = GAME_CONFIG.hasPrepStage
  ? [stage1, stage1a, stage2, stage3]
  : [stage1a, stage2, stage3];

hotspotStore.init();

export default function GameEngine({ setIsGameEnd }) {
  const [isEligibleToNext, setIsEligibleToNext] = useState(false);

  const [foundHotspots, setFoundHotspots] = useState(
    hotspotStore.getNewHotspot()
  );

  const [currentStage, setCurrentStage] = useState(0);
  const [currentStageImg, setCurrentStageImg] = useState(stages[currentStage]);

  const [showModal, setShowModal] = useState(true);

  const clingSoundRef = useRef();

  const [showPopupText, setShowPopupText] = useState(false);

  useEffect(() => {
    if (foundHotspots[currentStage] == 4) {
      setShowPopupText(true);

      if (GAME_CONFIG.hasPrepStage && currentStage == 0) {
        setIsEligibleToNext(true);
      } else {
        setTimeout(() => {
          setIsEligibleToNext(true);
        }, 5000);
      }

      // play cling sound
      clingSoundRef.current.play();
    } else {
      setShowPopupText(false);
      setIsEligibleToNext(false);
    }
  }, [currentStage, foundHotspots]);

  function updateHotspotCountInEachStage() {
    let foundHotspotsCopy = hotspotStore.getNewHotspot();
    foundHotspotsCopy[currentStage] = foundHotspotsCopy[currentStage] + 1;
    return foundHotspotsCopy;
  }

  function handleDeleteHotspot(e, index) {
    const foundHotspotsCopy = updateHotspotCountInEachStage();
    setFoundHotspots(foundHotspotsCopy);
    hotspotStore.setNewHotspot(foundHotspotsCopy);

    if (GAME_CONFIG.hasPrepStage) {
      if (currentStage == 0) {
        deleteHotspot(".custom-hotspot", index);
      }
      if (currentStage == 1) {
        deleteHotspot(".custom-hotspot", index);
      }
      if (currentStage == 2) {
        deleteHotspot(".custom-hotspot-2", index);
      }
      if (currentStage == 3) {
        deleteHotspot(".custom-hotspot-3", index);
      }
    } else {
      if (currentStage == 0) {
        deleteHotspot(".custom-hotspot", index);
      }
      if (currentStage == 1) {
        deleteHotspot(".custom-hotspot-2", index);
      }
      if (currentStage == 2) {
        deleteHotspot(".custom-hotspot-3", index);
      }
    }
  }

  function handleBack() {
    if (currentStage > 0) {
      setCurrentStage(currentStage - 1);
      setCurrentStageImg(stages[currentStage - 1]);
    }
  }

  function handleNext() {
    if (
      currentStage == GAME_CONFIG.lastStageIndex &&
      foundHotspots[GAME_CONFIG.lastStageIndex] == 4
    ) {
      setIsGameEnd(true);
    }
    if (currentStage < GAME_CONFIG.lastStageIndex) {
      setShowModal(true);
      setCurrentStage(currentStage + 1);
      setCurrentStageImg(stages[currentStage + 1]);
    }
  }

  let foundInstos = getFoundInstos(foundHotspots, currentStage);

  return (
    <div className={`game-engine ${currentStage == 0 && "red-eye-bg"}`}>
      <audio ref={clingSoundRef}>
        <source src="/tring-sound-effect-2.mp3" type="audio/mp3" />
        Your browser does not support the audio element.
      </audio>

      <h1
        className="big-title"
        style={{
          position: "fixed",
          top: 0,
          left: "50%",
          transform: "translateX(-50%)",
          zIndex: 99,
        }}
        data-aos="zoom-in"
      >
        <img src={Title360} alt="" style={{ verticalAlign: "middle" }} />
        Cari Insto
      </h1>

      <GamePanorama
        currentStage={currentStage}
        currentStageImg={currentStageImg}
        handleDeleteHotspot={handleDeleteHotspot}
      />

      {/* SHOW STORY TELLER MODAL FOR EACH STAGE */}
      {/* <StoryModal
        showModal={showModal}
        handleCloseModal={() => setShowModal(false)}
      /> */}

      {/* SHOW IF FOUND HOTSPOT IN CURRENT STAGE IS 3 */}

      <FPSImage currentStage={currentStage} />
      <CenteredInstoBottle
        foundHotspots={foundHotspots}
        currentStage={currentStage}
        setFoundHotspots={setFoundHotspots}
      />

      <GameOverlay
        isEligibleToNext={isEligibleToNext}
        foundHotspots={foundHotspots}
        currentStage={currentStage}
      />
      <GameHint
        showPopupText={showPopupText}
        isEligibleToNext={isEligibleToNext}
        currentStage={currentStage}
      />

      <div className="buttons">
        {currentStage > 0 ? (
          <button className="btn-back" onClick={handleBack}>
            Kembali
          </button>
        ) : (
          <div></div>
        )}

        <div className="btn-next-wrapper">
          <div className="found-instos">{foundInstos}</div>
          <button
            disabled={!isEligibleToNext}
            className="btn-next"
            onClick={handleNext}
          >
            Selanjutnya
          </button>
        </div>
      </div>
    </div>
  );
}
